import React, {useContext} from "react"
import AuthContext from "../../context/AuthContext";
import AdminNav from "../../components/AdminNav/AdminNav";
import useFunction from "../../hooks/useFunction";
//import './style.scss'

const UserAdmin = () => {

  const {user} = useContext(AuthContext)
  const {objIsEmpty} = useFunction()

  return (
    <div className="page-user-admin">
      {!objIsEmpty(user) && user.is_admin &&
        <>
          <AdminNav/>
        </>
      }
    </div>
  )
}

export default UserAdmin
